export function formatViewers(count: number | null): string {
  if (count === null) return "";
  if (count >= 1_000) {
    return `${(count / 1_000).toFixed(1).replace(/\.0$/, "")}K`;
  }
  return String(count);
}

export function timeAgo(
  isoString: string,
  options?: { prefix?: string },
): string {
  const diff = Date.now() - new Date(isoString).getTime();
  if (!Number.isFinite(diff)) return "Just started";
  const minutes = Math.floor(diff / 60_000);
  if (minutes < 1) return "Just started";
  const prefix = options?.prefix ? `${options.prefix} ` : "";
  if (minutes < 60) return `${prefix}${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  return `${prefix}${hours}h ago`;
}
